import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { removeScrollbar } from '@/styles/helpers';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import { Chip } from '@/components/UI/Chip/Chip';
import { Button } from '@/components/UI/Button/Button';
import { profileLayoutDesktopFrameStyles } from '@/features/Profile/core/ProfileLayout/ProfileLayout.styled';

export const TabsWrapper = styled.div`
  position: relative;
`;

export const ContentCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: 30px;
  ${profileLayoutDesktopFrameStyles}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
  }
`;

export const Title = styled(Typography.Header)`
  font-size: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    font-size: 18px;
    font-weight: 500;
  }
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
`;

export const RestoreEntryButton = styled.button`
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 15px;
  line-height: 100%;
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.system.blue};
`;

export const BulkPromotionEntryButton = styled(Button).attrs({
  appearance: 'transparent',
  hasPadding: false,
})`
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.system.blue};
  gap: 8px;

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.palette.system.deepBlue};
    }
  }
`;

export const Tabs = styled.div`
  ${removeScrollbar()}

  display: flex;
  overflow-x: auto;
  gap: 10px;
`;

export const TabCount = styled.div`
  margin-left: 5px;
`;

export const TabCountSkeleton = styled(SkeletonLoader).attrs({
  appearance: 'primary',
  height: 15,
  width: 15,
})`
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.secondary.border};
`;

export const Tab = styled(Chip)`
  flex: 0 0 auto;
  height: 40px;
`;

export const ArchiveInfoBox = styled(Typography.Body).attrs({
  $variant: '1',
})`
  width: 100%;
  font-size: 12px;
  padding: 15px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const ScrollerButton = styled.button<{ $isReversed?: boolean }>`
  position: absolute;
  top: 50%;
  ${({ $isReversed }) => ($isReversed ? 'left: 0' : 'right: 0')};
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border: none;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.system.white};
  box-shadow: 5px 10px 15px 0 rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transform: translateY(-50%);
  user-select: none;

  svg {
    transform: rotate(${({ $isReversed }) => ($isReversed ? '90' : '-90')}deg);
  }
`;
